import React, { useContext } from 'react'
import logoUTCColor from './../res/images/logo.png'
import Icon from '../res/icons';
import { Link } from 'react-router-dom';
import MenuMobile from './MenuMobile';
import { NavigationContext } from '../context/NavigationContext';

const NavBar = () => {
    const { setMenuVisible } = useContext(NavigationContext)

    return (
        <header>
            <img src={logoUTCColor} alt="Logo UTC" className="logo-utc" />
            <p className="page-title">Présentation de l'UV</p>
            <Link className="menu-button" onClick={() => setMenuVisible()}>
                <Icon name="hamburger" height={'24px'} fill="white" />
                <p>Menu</p>
            </Link>
            <p className="logo-nf05">NF05</p>
        </header>
    );
}

export default NavBar;